import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle, Phone, Mail } from "lucide-react";

interface ContactSidebarProps {
  programTitle?: string;
}

const ContactSidebar: React.FC<ContactSidebarProps> = ({ programTitle }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="bg-white rounded-2xl shadow-lg p-8 sticky top-8"
    >
      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
          <MessageCircle className="w-8 h-8 text-blue-600" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          Interested in This Program?
        </h3>
        <p className="text-gray-600 text-sm">
          Get in touch with our admissions team to learn more
          {programTitle ? ` about ${programTitle}` : ""} and explore your
          options.
        </p>
      </div>

      <Link
        to="/contact"
        className="block w-full bg-blue-600 text-white text-center py-4 rounded-xl font-semibold text-lg hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl"
      >
        Contact Us
      </Link>

      <div className="mt-6 space-y-3">
        <div className="flex items-center gap-3 text-gray-600">
          <Phone className="w-4 h-4 text-blue-600 flex-shrink-0" />
          <span className="text-sm">Schedule a consultation call</span>
        </div>
        <div className="flex items-center gap-3 text-gray-600">
          <Mail className="w-4 h-4 text-blue-600 flex-shrink-0" />
          <span className="text-sm">Get personalized program details</span>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactSidebar;
